import { render, staticRenderFns } from "./PaymentsTableMobile.vue?vue&type=template&id=28211c78&scoped=true"
import script from "./PaymentsTableMobile.vue?vue&type=script&lang=js"
export * from "./PaymentsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./PaymentsTableMobile.vue?vue&type=style&index=0&id=28211c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28211c78",
  null
  
)

export default component.exports